import { UAParser } from 'ua-parser-js';

import { isServer } from './env-helper';

const botUaRegex =
  /bot|crawl|spider|slurp|baidu|yandex|duckduckgo|bingbot|googlebot|ahrefsbot|semrushbot|mj12bot|dotbot|wget|curl|python-requests|java\/|scrapy|headless|phantomjs|selenium|puppeteer/i;

export const checkBotUserAgent = (): boolean => {
  if (isServer) return false;
  if (typeof navigator === 'undefined') return false;
  if (navigator.webdriver) return true;
  return botUaRegex.test(navigator.userAgent);
};

function getUaParserResult(userAgent = navigator.userAgent) {
  const parser = new UAParser(userAgent);
  return parser.getResult();
}

export function getDevice(userAgent = navigator.userAgent) {
  const { device, browser } = getUaParserResult(userAgent);
  if (device.model) return [device.model, browser.name].filter(Boolean).join(' ');
  return [browser.name, browser.version].filter(Boolean).join(' ');
}

export function getOs(userAgent = navigator.userAgent) {
  const { os } = getUaParserResult(userAgent);
  return [os.name, os.version].filter(Boolean).join(' ');
}

export const getUserAgentInfo = () => {
  const userAgent = isServer ? '' : window.navigator.userAgent.toLowerCase();

  const isIos =
    userAgent.includes('iphone') ||
    userAgent.includes('ipad') ||
    (userAgent.includes('mac') && window.navigator.maxTouchPoints > 1);
  const isAndroid = userAgent.includes('android');
  const isNotChrome = !userAgent.includes('chrome');
  const isIosSafari = isIos && isNotChrome;

  return {
    isIos,
    isAndroid,
    isNotChrome,
    isIosSafari,
  };
};

export const checkTouchDevice = () => {
  if (isServer) return false;
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

export const checkMobile = () => {
  if (isServer) return false;
  return (
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobi/i.test(navigator.userAgent.toLowerCase()) &&
    checkTouchDevice()
  );
};
